import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[var(--bg)]">
      <div className="text-center max-w-lg">
        <XCircle className="w-16 h-16 mx-auto text-[var(--accent)] mb-8" />
        <h1 className="font-anton uppercase text-5xl md:text-6xl tracking-tighter">
          Checkout cancelled
        </h1>
        <p className="text-[var(--text-dim)] mt-4">
          No worries — your cart is still saved. Send it whenever you're ready.
        </p>
        <Link
          to="/"
          data-testid="back-home-btn"
          className="inline-block mt-10 bg-[var(--text)] text-black px-8 py-4 uppercase tracking-widest text-sm font-bold hover:bg-[var(--accent)] hover:text-white transition-colors"
        >
          Back to store
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
